<template>
  <div class="main-conatiner" :style="{ '--footer-link-color': colors.secondaryText }">
    <div class="brand-section">
      <img v-if="isDark" src="/icons/Logo-dark.svg" class="brand" alt="Equirize Logo" />
      <img v-else src="/icons/Logo-light.svg" class="brand" alt="Equirize Logo" />
      <p :style="{ color: colors.primaryText }">
        EquiRize Securities Private Limited.
      </p>

      <ul class="social-icons" aria-label="Social media links">
        <li>
          <a href="https://www.facebook.com/profile.php?id=61581229511161"
            aria-label="Follow Equirize on Facebook (opens in new tab)" target="_blank" rel="noopener noreferrer"><img
              src="/social/facebook.svg" class="img-fluid" alt="Facebook Icon" aria-hidden="true" /></a>
        </li>
        <!-- <a href=""
          ><img src="/social/twitter.svg" class="img-fluid" alt="twitter"
        /></a> -->
        <li>
          <a  href="https://www.linkedin.com/company/equirize-securities-pvt-ltd/"
            aria-label="Follow Equirize on LinkedIn (opens in new tab)" target="_blank" rel="noopener noreferrer"><img
              src="/social/linkedin.svg" class="img-fluid" alt="LinkedIn Icon" aria-hidden="true" /></a>
        </li>
        <li>
          <a  href="https://www.instagram.com/equirizeinvest/"
            aria-label="Follow Equirize on Instagram (opens in new tab)" target="_blank" rel="noopener noreferrer"><img
              src="/social/instagram.svg" class="img-fluid" alt="Instagram Icon" aria-hidden="true" /></a>
        </li>
        <!-- <a href=""
          ><img src="/social/youtube.svg" class="img-fluid" alt="youtube"
        /></a> -->
      </ul>

      <FooterAppLinks />
    </div>

    <div>
      <h2>Legal & Compliance</h2>
      <ul class="subLinks">
        <!-- External link - no-prefetch to avoid loading bond/contact CSS on homepage -->
        <li>
          <NuxtLink to="/legal-compliance/investor-charter" role="link"
            :style="{ color: colors.secondaryText }" no-prefetch
            aria-label="Investor Charter: Rights and responsibilities of investors">
            Investor Charter
          </NuxtLink>
        </li>

        <!-- Internal policy links -->
        <li>
          <NuxtLink to="/legal-compliance/regulatory-disclosure" role="link"
            :style="{ color: colors.secondaryText }" no-prefetch
            aria-label="View Regulatory Disclosures and mandatory legal filings">
            Regulatory Disclosures
          </NuxtLink>
        </li>

        <li>
          <NuxtLink to="/legal-compliance/policies-and-procedure" role="link"
            :style="{ color: colors.secondaryText }" no-prefetch
            aria-label="Policies and Procedures: Operational guidelines and internal rules">
            Policies & Procedures
          </NuxtLink>
        </li>

        <!-- <NuxtLink
          :to="{ path: '/legal-compliance/risk-disclosure' }"
          :style="{ color: colors.secondaryText }"
        >
          Risk Disclosure
        </NuxtLink> -->

        <li>
          <NuxtLink to="/legal-compliance/grievance" role="link" :style="{ color: colors.secondaryText }"
            no-prefetch aria-label="Grievance Redressal Mechanism: Information on how to file a complaint">
            Grievance Redressal Mechanism
          </NuxtLink>
        </li>
      </ul>
    </div>

    <div>
      <h2>Quick Links</h2>
      <ul class="subLinks">
        <li>

          <a :href="investEquirizeUrl" class="sign_up_initiated" :style="{ color: colors.secondaryText }"
            aria-label="Login to Equirize">Login</a>
        </li>
        <li>

          <NuxtLink to="/privacy-policy" aria-label="Privacy Policy" :style="{ color: colors.secondaryText }"
            no-prefetch>
            Privacy Policy
          </NuxtLink>
        </li>

        <li>

          <NuxtLink to="/terms-and-conditions" aria-label="Terms & Conditions" :style="{ color: colors.secondaryText }"
            no-prefetch>
            Terms & Conditions
          </NuxtLink>
        </li>
        <li>

          <NuxtLink to="https://d1tqjc2k5caf7j.cloudfront.net/complaints-data-latest.pdf" target="_blank" external
            :style="{ color: colors.secondaryText }" no-prefetch role="link"
            aria-label="Investor Complaints Document (Opens in a new tab)">
            Investor Complaints
          </NuxtLink>
        </li>
      </ul>
    </div>

    <div>
      <h2>Help</h2>
      <ul class="subLinks">
        <!-- <a href="" :style="{ color: colors.secondaryText }">FAQs</a> -->
        <li>

          <NuxtLink to="/contact-us" aria-label="Contact Us" :style="{ color: colors.secondaryText }" no-prefetch>
            Contact
            Us</NuxtLink>
        </li>
        <li>
          <NuxtLink to="/sitemap" aria-label="Sitemap" :style="{ color: colors.secondaryText }" no-prefetch>Sitemap
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTheme } from "~/composables/useTheme";
import { useUtmTracking } from "~/composables/useUtmTracking";
import { useRoute } from "vue-router";
import { computed, ref, onMounted } from "vue";

const { colors, themeName } = useTheme();
const isDark = computed(() => themeName.value === "dark");
const { buildRedirectUrl } = useUtmTracking();
const route = useRoute();
const { investorUrl } = useInvestorPlatform();

// Use ref to avoid hydration mismatch - start with base URL, update on client
const investEquirizeUrl = ref(investorUrl("/login"));

onMounted(() => {
  // Update URL with UTM parameters only on client side
  investEquirizeUrl.value = buildRedirectUrl(
    investorUrl("/login"),
    route.path,
    "login-footer",
  );
});
</script>

<style scoped>
a {
  cursor: pointer;
}

.main-conatiner {
  display: flex;
  flex-direction: column;
  gap: 26px;
}

h2 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}

.social-icons {
  margin: 50px auto;
  display: flex;
  flex-direction: row;
  gap: 20px;
  list-style: none;
}

.social-icons a {
  display: inline-flex;
  border-radius: 4px;
}

.social-icons a:focus,
.social-icons a:focus-visible {
  outline: 2px solid #00007C;
  outline-offset: 2px;
}

.subLinks {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 18px;
  font-size: 15px;
  list-style: none;
}

.subLinks a {
  color: var(--footer-link-color);
}

/* Tablet (portrait & landscape) */
@media (min-width: 768px) {
  .main-conatiner {
    flex-direction: row;
    justify-content: space-between;
    gap: 26px;
  }

  h3 {
    font-size: 17px;
  }

  .subLinks {
    flex-direction: column;
    gap: 16px;
    font-size: 15px;
  }
}

/* Desktop (laptops and larger) */
@media (min-width: 1024px) {
  .brand-section {
    width: 50%;
  }

  .main-conatiner>div:not(.brand-section) {
    width: auto;
    /* remaining divs adapt naturally */
  }
}

.brand {
  width: 110px;
}

.sign_up_initiated {}
</style>
